<template>
  <div>
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9"> </v-col>
          <v-col
            cols="12"
            md="3"
            class="d-flex"
            :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : ''"
          >
            <div class="mr-2" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn-toggle v-model="toggleBreakpoint" dense>
                <v-btn @click="breakpoint = 0">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <v-btn @click="breakpoint = 'xs'">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :items-per-page="10"
        class="elevation-1 historic-bet"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
        :mobile-breakpoint="breakpoint"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>
        <template v-slot:item.name_user="{ item }">
          <p class="mb-0">{{ `${$t("punter")}: ${item.punter}` }}</p>
          Ag.:
          <a
            @click="
              $profile.showProfileDrawer(
                item.id_user,
                '/administrator/agents/getAgent'
              )
            "
            >{{ `${item.name_user}` }}</a
          >
        </template>

        <template v-slot:item.events="{ item }">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div class="py-2">
              <div
                v-for="(event, index) in item.events"
                :key="index"
                class="caption"
              >
                {{ event.description }} (
                {{ $infoTable.markets(event.id_market).name_market || "" }} -
                {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }} -
                {{ event.factor_event }}) &nbsp;
                <span
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event
                    )
                  "
                ></span>
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="primary"
                  v-if="event.live_event == '1'"
                >
                  {{ $t("live") }}
                </v-chip>
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="warning"
                  v-if="
                    legendActiveEvent[event.active_event] &&
                      event.status_event == 1
                  "
                >
                  {{ legendActiveEvent[event.active_event] }}
                </v-chip>
              </div>
            </div>
          </template>
          <template v-else>
            {{ item.qtd_events }}
          </template>
        </template>

        <template v-slot:item.date="{ item }">
          <span class="caption">{{ item.date }}</span>
        </template>

        <template v-slot:item.paid="{ item }">
          <v-icon :color="item.paid == 0 ? 'orange' : 'green'">{{
            item.paid | formatPaid
          }}</v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn-toggle dense>
            <v-btn
              small
              :title="$t('view')"
              @click="$bet.showBetDialog(item.id, item.printed)"
            >
              <v-icon size="24">mdi-magnify-plus-outline</v-icon>
            </v-btn>
            <v-btn v-if="payIsPossible && item.result_bet == 1 && item.paid != 1"
              small
              :title="$t('pay')"
              @click="$bet.showBetDialog(item.id, item.printed, true)"
            >
              <v-icon size="24">mdi-cash</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>

        <template v-slot:item.result_bet="{ item }">
          <div
            class="font-weight-black"
            v-html="$infoTable.conference(item.result_bet, item.status_bet)"
          ></div>
        </template>
      </v-data-table>
    </v-card>
    <!-- Resume Perído -->
    <div class="mt-4" v-if="resume.prizeTotal && resume.amountTotal">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">
              {{ $t("periodSummary") }}
              <div class="caption">{{ $store.state.rangeUI }}</div>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t("value") }}</td>
                    <td class="text-right green--text darken-4">
                      {{ resume.amountTotal }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("paidPremiuns") }}</td>
                    <td class="text-right red--text darken-4">
                      {{ resume.prizePaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("passibleAwards") }}</td>
                    <td class="text-right orange--text darken-4">
                      {{ resume.prizeNoPaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("totalPrizes") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.prizeTotal }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "administrator-bet-list-online",

  data: () => ({
    toggleBreakpoint: 0,
    breakpoint: 0,
    data: [],
    search: "",
    // Resume
    resume: {},
    agentRequired: false,
  }),
  mounted() {
    this.agentRequired = this.$route.name === "AdministratorAgentBetList";

    if (this.$vuetify.breakpoint.smAndDown) {
      this.breakpoint = "xs";
      this.toggleBreakpoint = 1;
    }
  },
  computed: {
    headers() {
      var items = [
        { text: "String p/ Search", value: "infoString", align: " d-none" },
        // Exibidos
        { text: this.$t("code"), value: "id" },
        { text: this.$t("informations"), value: "name_user" },
        { text: this.$t("events"), value: "events" },
        { text: this.$t("dateTime"), value: "date" },
        { text: this.$t("value"), value: "amount" },
        { text: this.$t("return"), value: "prize" },
        { text: this.$t("result"), value: "result_bet" },
        { text: this.$t("paid"), value: "paid" },
        { text: this.$t("actions"), value: "action" },
      ];

      // Insere o Qtd Events em uma coluna especifica apenas para desktop
      // if (this.$vuetify.breakpoint.smAndUp) {
      //   items.splice(3, 0, {
      //     text: "Qtd.",
      //     value: "qtd_events",
      //   });
      // }

      return items;
    },
    legendActiveEvent() {
      return {
        4: this.$t("canceledList"),
        5: this.$t("deferredList"),
        6: this.$t("canceledList"),
        7: this.$t("canceledList"),
      };
    },

    // ====================================================
    // Retrieve Filters:
    status() {
      return this.$store.state.filters.selectStatusBet.status;
    },
    result() {
      return this.$store.state.filters.selectResultBet.result;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agente() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    id_player() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
    sinalOption() {
      return this.$store.state.filters.sinal.option;
    },
    sinalValor() {
      return this.$store.state.filters.sinal.valor;
    },
    sinalAwardOption() {
      return this.$store.state.filters.sinalAward.option;
    },
    sinalAwardValor() {
      return this.$store.state.filters.sinalAward.valor;
    },
    originBet() {
      return this.$store.state.filters.groupOriginBet.value;
    },
    eventNumber() {
      return this.$store.state.filters.eventNumber.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // ====================================================
    // Retrieve Range:
    rangeDate() {
      return this.$store.state.range.date;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    payIsPossible() {
      return this.$store.state.operator && this.$store.state.operator.retail == 1
    }
  },
  watch: {
    refresh(val) {
      val && this.getBetsList();
      this.$store.commit("setRefresh", false);
    },
    saveFilters(val) {
      val && this.getBetsList();
    },
  },
  methods: {
    async getBetsList() {
      if (this.agentRequired && !this.id_agente) {
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);

        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("selectAgent"),
          color: "warning",
        });

        return;
      }

      const body = {
        ...this.rangeDate,
        id_regional: this.id_regional,
        id_local: this.id_local,
        id_agente: this.id_agente,
        status: this.status,
        resultado: this.result,
        sinal_option: this.sinalOption,
        sinal_valor: this.sinalValor,
        sinal_option_valor_premio: this.sinalAwardOption,
        sinal_valor_premio: this.sinalAwardValor,
        categoria: this.originBet,
        // bets_type: this.type,
        tipo: this.eventNumber,
        export: this.exportDoc,
      };

      let response;

      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "administrator/bets/list",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post("/administrator/bets/list", body);

        var data = response.length == 0 ? [] : response.dados.apostas;
        // Handle data (important!):
        this.data = await Promise.all(
          this.handleDate(data),
          this.handleInfos(data)
        );

        this.data.reverse();
        // Build Resume and add value to reducer
        this.resume = this.$resume.resumeBet(this.data);
      }
    },

    // Handle 'date'
    handleDate(data) {
      return data.map(async (item) => {
        item.date = new Date(item.date.replace(" ", "T")).toLocaleString();
        return item;
      });
    },

    // Handle 'string' para alguns dados serem encontrados na busca.
    handleInfos(data) {
      return data.map(async (item) => {
        let qtd_events = this.qtdEvents(item.n_events);
        let infoString = `${item.punter} ${item.name_user} ${qtd_events}`;
        for (const e of item.events) {
          infoString += `${e.description}
          ${this.$infoTable.markets(e.id_market).name_market}
          ${this.$infoTable.outcomes(e.id_outcome).name_outcome}
          ${this.$infoTable.results(item.result_bet)}`;
        }
        Object.assign(item, { infoString, qtd_events });
        return item;
      });
    },

    qtdEvents(val) {
      const text = {
        1: `1 (${this.$t("simple")})`,
        2: `2 (${this.$t("duo")})`,
        3: `3 (${this.$t("triple")})`,
      };
      return text[val] ? text[val] : `${val} ${this.$t("eventsLabel")}`;
    },
  },
  filters: {
    formatPaid(val) {
      const format = val == 1 ? "mdi-check" : "mdi-close";
      return format;
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table tbody td:last-child {
  height: 56px !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1) {
  display: none;
}
.historic-bet td.v-data-table__mobile-row:nth-child(2) {
  height: 56px !important;
  font-size: 18px;
}
</style>
